import { Link } from "react-router-dom";
import { SITE } from "../../config/site";

export default function Footer() {
  return (
    <footer className="border-t border-[#27272A] bg-[#050505]" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 sm:px-6 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <p className="font-serif text-lg font-semibold text-white">{SITE.name}</p>
          <p className="mt-2 text-sm leading-relaxed text-[#A1A1AA]">{SITE.tagline}</p>
          <p className="mt-4 text-sm text-[#A1A1AA]">
            Email:{" "}
            <a
              href={`mailto:${SITE.email}`}
              data-testid="footer-email-link"
              className="focus-gold text-[#D4AF37] underline-offset-4 hover:underline"
            >
              {SITE.email}
            </a>
          </p>
        </div>
        <nav aria-label="Footer navigation">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#D4AF37]">Pages</p>
          <ul className="mt-4 space-y-2.5 text-sm text-[#A1A1AA]">
            <li><Link className="focus-gold hover:text-white" to="/book" data-testid="footer-book-link">Book a Journey</Link></li>
            <li><Link className="focus-gold hover:text-white" to="/how-it-works" data-testid="footer-how-it-works-link">How It Works</Link></li>
            <li><Link className="focus-gold hover:text-white" to="/areas-covered" data-testid="footer-areas-link">Areas Covered</Link></li>
            <li><Link className="focus-gold hover:text-white" to="/drivers" data-testid="footer-drivers-link">Join as a Driver</Link></li>
            <li><Link className="focus-gold hover:text-white" to="/faqs" data-testid="footer-faqs-link">FAQs</Link></li>
            <li><Link className="focus-gold hover:text-white" to="/contact" data-testid="footer-contact-link">Contact</Link></li>
          </ul>
        </nav>
        <nav aria-label="Popular routes">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#D4AF37]">Popular routes</p>
          <ul className="mt-4 space-y-2.5 text-sm text-[#A1A1AA]">
            <li><Link className="focus-gold hover:text-white" to="/great-dunmow-to-london" data-testid="footer-route-dunmow">Great Dunmow to London</Link></li>
            <li><Link className="focus-gold hover:text-white" to="/felsted-flitch-green-to-london" data-testid="footer-route-felsted">Felsted &amp; Flitch Green to London</Link></li>
            <li><Link className="focus-gold hover:text-white" to="/bishops-stortford-to-london" data-testid="footer-route-stortford">Bishop's Stortford to London</Link></li>
            <li><Link className="focus-gold hover:text-white" to="/stansted-mountfitchet-takeley-to-london" data-testid="footer-route-stansted">Stansted Mountfitchet &amp; Takeley to London</Link></li>
          </ul>
        </nav>
        <nav aria-label="Legal links">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#D4AF37]">Legal</p>
          <ul className="mt-4 space-y-2.5 text-sm text-[#A1A1AA]">
            <li><Link className="focus-gold hover:text-white" to="/privacy-policy" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link className="focus-gold hover:text-white" to="/terms" data-testid="footer-terms-link">Terms &amp; Conditions</Link></li>
          </ul>
          <p className="mt-6 border-t border-[#1A1A1A] pt-4 text-xs leading-relaxed text-[#71717A]" data-testid="footer-trading-entity">
            {SITE.name} — {SITE.tradingEntity}
          </p>
          <p className="mt-3 text-xs leading-relaxed text-[#71717A]">
            This website never takes passenger payments. Passengers pay their driver £100 in
            cash or by card inside the cab at the end of the journey.
          </p>
        </nav>
      </div>
      <div className="border-t border-[#1A1A1A] px-4 py-5 text-center text-xs text-[#71717A]">
        {SITE.name} — {SITE.domain} — pre-booking request service. {SITE.availabilityMessage}
      </div>
    </footer>
  );
}
